import styled from 'styled-components'
import { colors, media, sizes } from 'client/styles'
import { Content, Header } from 'client/components/Modal/styles'

export const CancellationPoliciesBase = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 2px solid ${colors.grey4};
  padding-block: 20px;
  padding-inline: 20px;
  min-height: 245px;

  ${media.mobile} {
    max-width: 400px;
  }

  ${Content} {
    overflow: unset;
  }

  ${Header} {
    background-color: unset;
  }

  @media screen and (max-width: ${sizes.desktop - 1}px) {
    max-width: 100%;
    width: 100%;
    margin-block-start: 15px;
  }
`

export const Title = styled.div`
  display: flex;
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
  color: ${colors.grey1};

  padding-block-end: 20px;
`
